import { useMemo, useState } from 'react'
import { getHistoricoLeituraPeriodoLote } from '../../../../services/api/https/picking/picking.http'
import { errorHandler } from '../../../../services/util/error.service'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

const INITIAL_STATE = {
  data: [],
  periodo: getPeriodoMesAtual(),
  selectedEmpresa: null,
  errorMessage: null,
  isLoading: false,
}

export default function useHistoricoLeituraLote() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      onPeriodoInicialChange(dataInicial) {
        setState(prev => ({
          ...prev,
          periodo: {
            ...prev.periodo,
            dataInicial,
          },
        }))
      },

      onPeriodoFinalChange(dataFinal) {
        setState(prev => ({
          ...prev,
          periodo: {
            ...prev.periodo,
            dataFinal,
          },
        }))
      },

      setSelectedEmpresa(empresa) {
        setState(prev => ({
          ...prev,
          selectedEmpresa: empresa,
        }))
      },

      resetMessage() {
        setState(prev => ({
          ...prev,
          errorMessage: null,
        }))
      },

      exportarExcel() {
        if (!state.data || state.data.length === 0) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Não existem informações para serem exportadas',
          }))
          return
        }

        const colunas = [
          ['Código Produto', 'Descrição', 'Quantidade', 'Lote', 'Num. Referência', 'Observação'],
        ]

        state.data.forEach(item => {
          colunas.push([
            item.codigo_produto,
            item.descricao,
            item.quantidade,
            item.lote,
            item.referencia,
            item.observacao,
          ])
        })

        const nomeEmpresa = state.selectedEmpresa ? state.selectedEmpresa.name : 'empresa'
        const nomeArquivo = `historico_Periodo_Lote_${nomeEmpresa}.xlsx`

        gerarArquivoExcel('Histórico Leitura Lote', colunas, nomeArquivo)
      },

      async buscarDados(tp_id) {
        if (!tp_id) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Selecione um TP antes de realizar a busca.',
          }))
          return
        }

        if (!state.selectedEmpresa || !state.selectedEmpresa.id) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Selecione uma empresa antes de realizar a busca.',
          }))
          return
        }

        const { dataInicial, dataFinal } = state.periodo

        if (!dataInicial || !dataFinal) {
          setState(prev => ({
            ...prev,
            errorMessage: 'Informe o período inicial e final para realizar a busca.',
          }))
          return
        }

        try {
          setState(prev => ({
            ...prev,
            isLoading: true,
            errorMessage: null,
          }))

          const dados = await getHistoricoLeituraPeriodoLote(
            tp_id,
            dataInicial,
            dataFinal,
            state.selectedEmpresa.id,
          )

          setState(prev => ({
            ...prev,
            data: dados || [],
            isLoading: false,
          }))
        } catch (error) {
          setState(prev => ({
            ...prev,
            errorMessage: errorHandler(error),
            isLoading: false,
          }))
        }
      },
    }
  }, [state.periodo, state.selectedEmpresa, state.data])

  return { state, localDispatch }
}
